var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Team extends Component {
    constructor() {
        super('Team', false);
        this.updateMenuMaxHeight = () => {
            $('.module-team-member-text').each((text) => {
                text.css('--max-height', text.find('div').height() + 'px');
            });
        };
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(() => {
                    this.updateMenuMaxHeight();
                });
            }
            else {
                window.addEventListener('load', () => {
                    this.updateMenuMaxHeight();
                });
            }
            $(window).on('resize', () => {
                this.updateMenuMaxHeight();
            });
            $('.link-toggle-team-member-text').on('click', (event, link) => {
                event.preventDefault();
                if (link.hasClass('is-active')) {
                    link.removeClass('is-active');
                    link.find('.btn-more').removeClass('is-active');
                    link.parents('.module-team-member').find('.module-team-member-text').removeClass('is-active');
                }
                else {
                    $('.link-toggle-team-member-text').removeClass('is-active');
                    $('.btn-more').removeClass('is-active');
                    $('.module-team-member-text').removeClass('is-active');
                    link.addClass('is-active');
                    link.find('.btn-more').addClass('is-active');
                    link.parents('.module-team-member').find('.module-team-member-text').addClass('is-active');
                }
            });
            this.success();
        });
    }
}
